import audio.*
import com.github.chosamuel.kishibe.application.*
import com.github.chosamuel.kishibe.application.renderer.Color
import com.github.chosamuel.kishibe.application.renderer.clear
import com.github.chosamuel.kishibe.graphics.createMesh
import com.github.chosamuel.kishibe.math.Vector2
import com.github.chosamuel.kishibe.math.map
import com.github.chosamuel.kishibe.webgl.createShader
import com.github.chosamuel.tonejs.core.Tone
import geometry.Eye
import geometry.PolarGrid
import kotlinx.browser.window
import org.khronos.webgl.WebGLRenderingContext
import org.w3c.dom.events.KeyboardEvent
import pipeline.createEyelidMesh
import pipeline.createIrisMesh
import shaders.eyeVS
import shaders.fs
import shaders.irisVS
import kotlin.js.Date
import kotlin.math.PI
import kotlin.math.floor
import kotlin.math.sin
import kotlin.random.Random

typealias  GL = WebGLRenderingContext

fun main() {
    console.log("PHOSPHENE III")
}

var dm = Vector2(0.0)
var tm = Vector2(0.0)
const val numRungs = 2
const val numSpokes = 180
var toneStarted = false

val app = Application {
    Program {
        //IRIS
        //val defaultShader = createShader()
        val irisShader = createShader(irisVS,fs)

        //EYE LID
        val eyeLid = Eye(Vector2(
            getWidth() * 0.5,
            getHeight() * 0.52
        ),getWidth()*0.3,200)
        val eyelidShader= createShader(eyeVS,fs)
        var eyelidCounter = 0
        var eyelidKeyframe = Random.nextInt(30,60)

        //MOUSE EVENTS
        var m = Vector2(getWidth()*0.5,getHeight()*0.5)
        dm = Vector2(getWidth()*0.5,getHeight()*0.5)
        tm = Vector2(getWidth()*0.5,getHeight()*0.5)
        var mouseActive = false
        val seed = Random.nextDouble(999.999)
        var mouseKeyframe = Random.nextInt(30,60)
        var mouseActivityKeyframe = 0
        fun mouseActivation(){
            mouseActive = true
            mouseActivityKeyframe = frameCount + 600
        }
        window.addEventListener("mousemove", {mouseActivation()})

        //AUDIO
        setupAudio()
        var looping = false
        var started = false
        var startTime = 0


        onClick = {
            if(!toneStarted){
                toneStarted = true
            }
            mouseActivation()
            Tone.start()
           if(!started){
                window.setInterval({
                   if(whichLoop == 0){
                       if(looping) loopA()
                   } else {
                       if(looping) loopB()
                   }
                },(js("Tone.Time('16n').toSeconds() * 30") as Int)*1000)
            }
            if(!started){
                looping = true
            }
            started = true
            if(toneStarted && !eyeLid.triggered && looping) {
                triggerTwinkle()
            }
            eyeLid.trigger()
        }
        window.addEventListener("keydown",{
            val e = it as KeyboardEvent
            if(it.key == " "){
                if(toneStarted){
                    looping = !looping
                }
            }
        })

        Draw {
            //AUDIO
            val freq = map(
                -1.0,
                1.0,
                300.0,
                1000.0,
                sin(frameCount * 0.0001)
            )
            lowPass.set(jsObject{
                frequency =  freq
            })

            //console.log("$frameCount $mouseActivityKeyframe")
            clear(0.0)
            //MOUSE EVENTS
            if(mouseActive) {
                m = Vector2(mouseX,mouseY)
            }
            if(frameCount > mouseActivityKeyframe && mouseActive){
                mouseKeyframe = Random.nextInt(15,120) + frameCount
                mouseActive = false
            }
            if(!mouseActive){
                if(frameCount == mouseKeyframe){
                    m = Vector2(
                        Random.nextDouble(getWidth()),
                        Random.nextDouble(getHeight()),
                    )
                    mouseKeyframe = Random.nextInt(15,120) + frameCount
                }
            }
            ///////////////////////
            // IRIS
            ///////////////////////
            //UPDATE MOUSE FOR IRIS
            dm += (m-dm) * 0.075
            //CREATE MESH
            val irisMesh = createIrisMesh()
            irisShader.use()
            irisShader.setUniform1f("time",frameCount*1.5.toFloat())
            irisShader.setUniform1f("pi", PI.toFloat())
            irisShader.setUniform1f("numRungs",numRungs.toFloat())
            irisShader.setUniform1f("numSpokes",numSpokes.toFloat())
            irisShader.setUniform1f("seed",seed.toFloat())
            irisMesh.draw(GL.TRIANGLES)

            ///////////////////////
            // EYE LID
            ///////////////////////
            //UPDATE MOUSE FOR EYELID
            tm += (m - tm) * 0.05
            val tmx = tm.x/getWidth()*2.0 - 1.0
            //rotate lid with mousePos
            eyeLid.rotation = PI - (tmx * 0.25)
            //continuously update to listen for trigger
            eyeLid.update()
            val eyelidMesh = createEyelidMesh(eyeLid)
            eyelidShader.use()
            eyelidShader.setUniform1f("time",frameCount*1.5.toFloat())
            eyelidShader.setUniform1f("seed",seed.toFloat())
            eyelidMesh.draw(GL.TRIANGLE_STRIP)

            //RANDOM BLINKS
            if(frameCount == eyelidKeyframe){
                if(toneStarted && !eyeLid.triggered && looping){
                    triggerTwinkle()
                }
                eyeLid.trigger()
                eyelidKeyframe = Random.nextInt(30,600) + frameCount
            }
        }
    }
}
